// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FKk0F","content":"styles_content__1zOoX","row":"styles_row__nGZVi","footer":"styles_footer__9Xg7D","phraseLength":"styles_phraseLength__Z1Pnt"};